import { render, staticRenderFns } from "./NewslettersV2.vue?vue&type=template&id=7dc4c4e3&scoped=true&"
import script from "./NewslettersV2.vue?vue&type=script&lang=js&"
export * from "./NewslettersV2.vue?vue&type=script&lang=js&"
import style0 from "./NewslettersV2.vue?vue&type=style&index=0&id=7dc4c4e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc4c4e3",
  null
  
)

export default component.exports